function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 38,
  r: 38,
  fill: "#E6F0EF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0003 17.1665C26.5003 17.1665 17.167 26.4998 17.167 37.9998C17.167 49.4998 26.5003 58.8332 38.0003 58.8332C49.5003 58.8332 58.8337 49.4998 58.8337 37.9998C58.8337 26.4998 49.5003 17.1665 38.0003 17.1665ZM38.0003 54.6665C28.8128 54.6665 21.3337 47.1873 21.3337 37.9998C21.3337 28.8123 28.8128 21.3332 38.0003 21.3332C47.1878 21.3332 54.667 28.8123 54.667 37.9998C54.667 47.1873 47.1878 54.6665 38.0003 54.6665ZM47.5628 28.7915L33.8337 42.5207L28.4378 37.1457L25.5003 40.0832L33.8337 48.4165L50.5003 31.7498L47.5628 28.7915Z",
  fill: "#0CAFA0"
});

function SvgSuccessicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.e847e45c.svg";
export { ForwardRef as ReactComponent };